import React, { useState } from "react";

interface GaugeProps {
  value: number; // 0–100
  gaugeColors?: string[]; // 3 colors
  needleColor?: string;
}

const GaugeChart: React.FC<GaugeProps> = ({
  value,
  gaugeColors = ["#F22E57", "#575CFF", "#E3E4E5"],
  needleColor = "#575CFF",
}) => {
  const [hover, setHover] = useState(false);

  // Needle angle: 0 → -90deg, 100 → +90deg
  const angle = (value / 100) * 180 - 90;

  return (
    <div
      style={{
        position: "relative",
        width: "300px",
        height: "150px", // half circle
        margin: "auto",
        overflow: "hidden",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* Semi circle arc (3 colored segments) */}
      <div
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: `conic-gradient(
            ${gaugeColors[0]} 0deg 60deg,
            ${gaugeColors[1]} 60deg 120deg,
            ${gaugeColors[2]} 120deg 180deg,
            transparent 180deg 360deg
          )`,
          transform: "rotate(-90deg)",
        }}
      />

      {/* Inner cutout (hollow effect) */}
      <div
        style={{
          position: "absolute",
          top: "17%",
          left: "8%",
          width: "253px",
          height: "254px",
          borderRadius: "100%",
          background: "#fff",
        }}
      />

      {/* Needle */}
      <div
        style={{
          position: "absolute",
          bottom: 7,
          left: "50%",
          transform: `rotate(${angle}deg)`,
          transformOrigin: "bottom center",
          width: 0,
          height: 0,
          borderLeft:"5px solid transparent",
          borderRight: "5px solid transparent",
          borderBottom: `80px solid ${needleColor}`,
          borderRadius:'12px'
        }}
      />

      {/* Center circle */}
      {/* <div
        style={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          background: needleColor,
        }}
      /> */}

      {/* Tooltip */}
      {hover && (
        <div
          style={{
            position: "absolute",
            bottom: "65%",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#333",
            color: "#fff",
            padding: "4px 8px",
            borderRadius: "6px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            pointerEvents: "none",
          }}
        >
          {value}%
        </div>
      )}
    </div>
  );
};

export default GaugeChart;
